"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.BuildBody = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var case_evidence_table2_1 = require("../../case-evidence-table/case-evidence-table2");
var editorIssues = __importStar(require("../../common/editor-issues"));
var classnames_1 = __importDefault(require("classnames"));
var ui_common_1 = require("@codametrix/ui-common");
/**
 * React component that displays a build body
 * @param medicalCode
 * @param panelActivations
 * @param onFeatureSelection
 * @returns
 */
var BuildBody = function (medicalCode, techTransaction, panelActivations, codeEdits, onFeatureSelection) {
    var styleClasses = ["code-header", "code-body", 'transaction-body'];
    if (ui_common_1.cmxTypeguards.isZippedCodeBlock(medicalCode)) {
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    }
    else {
        var messages = codeEdits[medicalCode.code]
            ? editorIssues.formatEditGroup(codeEdits[medicalCode.code], 0)
            : false;
        return ((0, jsx_runtime_1.jsx)("div", __assign({ className: (0, classnames_1["default"])(styleClasses) }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "case-evidence-container" }, { children: [messages && ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "col-artifacts message-wrap" }, { children: [(0, jsx_runtime_1.jsx)("div", { className: "col-code" }), (0, jsx_runtime_1.jsx)("div", __assign({ className: "col-artifacts col-messages" }, { children: messages }))] }))), (0, jsx_runtime_1.jsx)(case_evidence_table2_1.CaseEvidenceTable2, { panelActivations: panelActivations, onFeatureSelection: onFeatureSelection, chargeSessionCode: medicalCode, techTransaction: techTransaction })] })) })));
    }
};
exports.BuildBody = BuildBody;
//# sourceMappingURL=transaction-body.js.map